
import { getLinkPropertyPathsForElement, getNearestParentLinkElement, isLinkElement } from "@/futurelayer/links/links";
import { findNode } from "@/lib/tree/tree";
import { documentStore, singularityStore } from "@/store/store";
import { TreeNode } from "@/types/tree";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class EditLinkButton extends Vue {
  @Prop()
  elementId!: TreeNode["id"];

  editLink() {

    var element = findNode(documentStore.document.tree, this.elementId);
    if (!element) return;

    if (!isLinkElement(element.data.type)) {
      element = getNearestParentLinkElement(element);
    }

    if (!element) return;
    if (!isLinkElement(element.data.type)) return;

    const linkPropertyPaths = getLinkPropertyPathsForElement(element.data.type);
    if (!linkPropertyPaths) return;

    singularityStore.setLinkEditorPanelState({
      elementId: element.id,
      linkPropertyPaths: linkPropertyPaths
    });
    singularityStore.setSingularityLeftPanel("link_editor");
  }
}
